var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background":"red"},attrs:{"id":"app"}},[_c('div',{staticClass:"h-100",attrs:{"id":"body-bg"}},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }